var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component> <div class=\"shopping-cart-bg\"> <div class=\"shopping-cart-wrapper col-md-4\"> <div class=\"shopping-cart\"> <h2 ng-i18next>reservation_customer.shopping_cart</h2> <div class=\"basketpopup {{$ctrl.winresReservationContext.showBasketPopup}}\"> <p> {{'reservation_customer.Info_saved' | i18next}}<br/> {{'reservation_customer.Choose_next' | i18next}} </p> </div> <reservation-errors ng-if=\"$ctrl.showErrors === 'true'\"> </reservation-errors> <div class=\"shopping-cart-items\" ng-transclude=\"winresReservationShoppingTabsItems\"> </div> </div> </div> </div> </web-component>";
var id1="winresReservationShoppingTabs.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationShoppingTabs/winresReservationShoppingTabs.html
// module id = 391
// module chunks = 2